import axios from 'axios';

const BASE_URL = 'https://rdc-api2-partenaire-test.omnitechafrica.com/api/rakakash';
const CREDENTIALS = {
    username: 'innovate',
    password: '0unVvESyMs79JsH', 
};

export const getToken = async () => {
    try {
        const response = await axios.post(
            `${BASE_URL}/oauth`,
            {
                consumerid: 'aqza52dc112-3df6-11ee-95bc-0050568166da789', 
                consumersecret: '96abfbbfeb745b63744d00d3c9e39687ba32f7ed', 
            },
            {
                headers: {
                    'Content-Type': 'application/json',
                },
                auth: CREDENTIALS,
                mode: 'no-cors',
            }
        );
        return response.data.token;
    } catch (error) {
        console.error('Erreur lors de la récupération du token:', error);
        throw new Error('Impossible de récupérer le token');
    }
};

export const initPayment = async (token, rakakashNumber, amount = '50') => {
    try {
        const response = await axios.post(
            `${BASE_URL}/initpayment`,
            {
                product_description: 'Facture AS-172',
                merchant_name: 'DIGIS ASSUR',
                merchant_id: 'DIGIS01',
                amount,
                currency: 'USD',
                rakakash_number: rakakashNumber,
                merchant_logo: 'https://digis-assur.weelitre.pro/_next/image/?url=%2F_next%2Fstatic%2Fmedia%2Fdark.8cf718c0.png',
                callback_url: 'https://digis-assur.weelitre.pro',
                external_id: 'DIGIS01-29325691',
            },
            {
                headers: {
                    'Content-Type': 'application/json',
                    Authorization: `${token}`,
                },
            }
        );
        return response.data;
    } catch (error) {
        console.error('Erreur lors de l\'initialisation du paiement:', error);
        throw new Error('Impossible d\'initialiser le paiement');
    }
};

export const confirmPayment = async (token, otpCode) => {
    try {
        const response = await axios.post(
            `${BASE_URL}/confirmpayment`,
            {
                otp_code: otpCode,
            },
            {
                headers: {
                    'Content-Type': 'application/json',
                    Authorization: `${token}`,
                },
            }
        );
        return response.data;
    } catch (error) {
        console.error('Erreur lors de la confirmation du paiement:', error);
        throw new Error('Impossible de confirmer le paiement');
    }
};
